import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, Toaster } from '@myvault/shared/hooks';
import { setTokenProvider } from '@myvault/api-client';

import { AppRoutes } from './routes';
import { ErrorBoundary } from './features/errors';
import { PersonaIndicator } from './features/dev';

// Configure API client to use stored auth token
const TOKEN_KEY = 'myvault_access_token';
setTokenProvider(async () => localStorage.getItem(TOKEN_KEY));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider
            onLoginRedirect={() => window.location.replace('/dashboard')}
            onLogoutRedirect={() => window.location.replace('/login')}
          >
            <Toaster>
              <AppRoutes />
              {/* BRD-DEV-001: Floating persona indicator in dev mode */}
              {import.meta.env.DEV && <PersonaIndicator />}
            </Toaster>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
